<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <div class="d-inline-block" style="max-width: 300px">
              <v-select
                v-model="estadoInscripcion"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Preinscrito', value: estadosInscripcionesEnum.PREINSCRITO },
                  { text: 'Inscrito', value: estadosInscripcionesEnum.INSCRITO },
                  { text: 'Retirado', value: estadosInscripcionesEnum.RETIRADO },
                  { text: 'Cambiado', value: estadosInscripcionesEnum.CAMBIADO },
                  { text: 'Congelado', value: estadosInscripcionesEnum.CONGELADO },
                ]"
                label="Estado inscripción"
                outlined
                dense
                hide-details
                @change="listar"></v-select>
            </div>

            <v-btn
              class="mx-1"
              title="Descargar Excel"
              small
              :disabled="descargandoExcel"
              :loading="descargandoExcel"
              @click="obtenerExcelInscripcionesProgramasVinculados">
              <v-icon>mdi-file-excel</v-icon>

              Descargar Excel
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoInscripciones
              ref="listadoRef"
              :items="items"
              :cargando="cargando"
              :itemsYaSeleccionados="[]"
              :universidadId="universidadId" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import layoutMixin from '../mixins/layout.mixin';
import ListadoInscripciones from './ListadoInscripciones.vue';
import InscripcionesService from '../services/inscripcion.service';
import { ESTADOS_INCRIPCIONES_ENUM } from '../utils/constantes';
import { mapGetters } from 'vuex';
import InscripcionesExcelService from '../services/inscripcion-excel.service';

export default {
  name: 'ModalVisualizarInscripciones',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoInscripciones,
  },
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      estadoInscripcion: ESTADOS_INCRIPCIONES_ENUM.INSCRITO,
      estadosInscripcionesEnum: ESTADOS_INCRIPCIONES_ENUM,
      descargandoExcel: false,
    };
  },
  computed: {
    ...mapGetters('pago', ['getFiltrarPorSede']),
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        programaNombre: data.programaNombre,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      this.items = [];

      const params = {
        programaUniversidadId: this.form.id,
        estadoInscripcion: this.estadoInscripcion,
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
      };

      this.obtenerDatosConNotificacion(
        InscripcionesService.findAllPorProgramaUniversidadVerificacion,
        'items',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    async obtenerExcelInscripcionesProgramasVinculados() {
      this.descargandoExcel = true;

      const opciones = {
        params: {
          programaUniversidadId: this.form.id,
        },
      };

      try {
        const { data } = await InscripcionesExcelService.findAllPorProgramaUniversidadVerificacion(opciones);
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const nombreExcel = `Inscritos_${this.form.codigo}_${this.form.programaNombre}`
          .toUpperCase()
          .split(' ')
          .join('_');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', nombreExcel);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: 'Descarga exitosa',
          type: 'success',
        });
      } catch (error) {
        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Error al descargar el archivo',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>